var React = require('react');

function Disc (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M140.839 21.7796C226.57 7.41967 307.597 64.6028 321.817 149.502C336.038 234.4 278.067 314.866 192.336 329.225C106.605 343.585 25.5778 286.402 11.3573 201.503C-2.86318 116.605 55.1077 36.1395 140.839 21.7796Z","fill":"#2B5EA1"}));
}

Disc.defaultProps = {"width":"0","height":"0","viewBox":"0 0 344 351","fill":"none","className":"shape","id":"disc"};

module.exports = Disc;

Disc.default = Disc;
